import axios, { AxiosResponse } from "axios"
import {
  SessionBySmsPayload,
  SessionBySmsResponse,
  CustomerDataPayload,
  CustomerDataResponse
} from "../types/ClaroMultiBff"
import { mockedSmsResponseData, mockedTokenAAResponseData } from "../mocks/ClaroMultiBff"

class ClaroMultiBffService {
  private readonly BFF_CLARO_MULTI_URL = process.env.claroMultiBffUrl
  private readonly sessionBySMSUrl = `${this.BFF_CLARO_MULTI_URL}/session-id/sessionBySMS`
  private readonly customerDataUrl = `${this.BFF_CLARO_MULTI_URL}/msisdn-details/customer-data`

  constructor() {
    return
  }

  async getSessionBySms({
    cpf,
    msisdn,
    code,
    token
  }: SessionBySmsPayload): Promise<
    AxiosResponse<SessionBySmsResponse>
  > {
    if (cpf in mockedSmsResponseData) {
      const data = mockedSmsResponseData[cpf];
      
      return {
        data: data,
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {} as any,
      } as AxiosResponse<SessionBySmsResponse>
    }

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-channel": "ecommerce",
      "x-segment": "pf",
      "x-partner": "",
      "x-customer-journey": "prospect"
    }

    const body = {
      code,
      token,
      msisdn,
      cpf
    }

    return await axios.post<SessionBySmsResponse>(
      this.sessionBySMSUrl,
      body,
      { headers }
    )
  }

  async getCustomerData({
    tokenId
  }: CustomerDataPayload): Promise<
    AxiosResponse<CustomerDataResponse>
  > {
    if(tokenId in mockedTokenAAResponseData) {
      return {
        data: mockedTokenAAResponseData[tokenId],
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {} as any,
      } as AxiosResponse<CustomerDataResponse>
    }


    const headers = {
      'Content-Type': "application/json",
      'sessionid': tokenId,
    }

    return await axios.get<CustomerDataResponse>(
      this.customerDataUrl,
      { headers }
    )
  }
}

export default new ClaroMultiBffService()
